var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00287 9.86535C8.50046 9.86535 8.92585 9.68818 9.27905 9.33385C9.63225 8.97952 9.80885 8.55356 9.80885 8.05598C9.80885 7.55839 9.63168 7.133 9.27735 6.7798C8.92302 6.4266 8.49706 6.25 7.99948 6.25C7.50189 6.25 7.0765 6.42717 6.7233 6.7815C6.3701 7.13583 6.1935 7.56179 6.1935 8.05938C6.1935 8.55696 6.37067 8.98235 6.725 9.33555C7.07933 9.68875 7.50529 9.86535 8.00287 9.86535ZM8.00117 19.5096C5.48453 17.3288 3.59735 15.2993 2.33965 13.4211C1.08197 11.5429 0.453125 9.81857 0.453125 8.24805C0.453125 5.94038 1.1996 4.07213 2.69255 2.64328C4.18548 1.21443 5.95503 0.5 8.00117 0.5C10.0473 0.5 11.8169 1.21443 13.3098 2.64328C14.8027 4.07213 15.5492 5.94038 15.5492 8.24805C15.5492 9.81857 14.9204 11.5429 13.6627 13.4211C12.405 15.2993 10.5178 17.3288 8.00117 19.5096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.343ebf6ba32ba3c7caa8e65ee391df5c.svg";
export { ForwardRef as ReactComponent };